import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService, FormServiceResolver } from 'src/app/core/services/v2/form.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { FormDoc } from '../../../core/models/physician/form-doc';

@Component({
  selector: 'app-form-document-preview',
  templateUrl: './form-document-preview.component.html',
  styleUrls: ['./form-document-preview.component.scss']
})
export class FormDocumentPreviewComponent implements OnInit {

  id: number;
  formDocument: FormDoc;


  constructor(
    private formServiceResolver: FormServiceResolver,
    private route: ActivatedRoute,
    private loaderService: WindowLoaderService, 
    private router: Router, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FormDocumentPreviewComponent>
    ) {
      if (data) {
        this.id = data.formId;
        
      }
    };

  ngOnInit() {
    this.route.params.subscribe(
      (params) => {
        if(this.id <=0){
          this.id = +params['id'];
        }
        this.getFormDocumentDetails();
      },
      (error) => { console.error(error); }
    );
  }

  getFormDocumentDetails() {

    var self = this;
    this.loaderService.show();
    this.formServiceResolver.getFormService().subscribe(  fsvc =>
    
      fsvc.getFormDoc(self.id).subscribe(
      (formd) => {
        this.formDocument = formd.result;
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    )

    );
  }

  edit()
  {
    this.formServiceResolver.getFormDetailsRoute().subscribe( spaRoute => 
      
      {
        this.router.navigate([`${spaRoute}${this.id}`]);
        this.dialogRef.close();
      });


  }

}
